import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { QrViewComponent } from '@app/components/qr-view/qr-view.component';
import { ActivitySectionDirective, UserActivityClickTrackingDirective } from '@core';
import { animate, style, transition, trigger } from '@angular/animations';

// @TODO: User signals.

@Component({
  selector: 'app-get-rewarded-tab',
  styleUrls: ['./get-rewarded-tab.component.scss'],
  templateUrl: './get-rewarded-tab.component.html',
  imports: [
    QrViewComponent,
    ActivitySectionDirective,
    UserActivityClickTrackingDirective,
    QrViewComponent,
  ],
  host: {
    'class': 'page',
  },
  animations: [
    trigger('InOutAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms ease-in-out', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('400ms ease-in-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetRewardedTabComponent {

  protected readonly showQRCode = signal<{
    title: string;
    description: string;
    imgSrc: string;
  } | null>(null);

}
